import React from "react";
import { Alert, AlertIcon, AlertTitle, AlertDescription, Box, Button } from "@chakra-ui/react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }
  static getDerivedStateFromError(error) {
    return { err: error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }
  render() {
    if (this.state.err) {
      return (
        <Box p={6}>
          <Alert status="error" borderRadius="md" flexDirection="column" alignItems="flex-start" p={6}>
            <AlertIcon boxSize="24px" mb={2} />
            <AlertTitle fontSize="lg" mb={2}>Something went wrong</AlertTitle>
            <AlertDescription mb={4} whiteSpace="pre-wrap" fontSize="sm" color="gray.600">
              {String(this.state.err?.message || this.state.err)}
            </AlertDescription>
            <Button
              size="sm"
              colorScheme="red"
              variant="outline"
              onClick={() => this.setState({ err: null })}
            >
              Try again
            </Button>
          </Alert>
        </Box>
      );
    }
    return this.props.children;
  }
}
